import { render, staticRenderFns } from "./pay-page.vue?vue&type=template&id=5697875b"
import script from "./pay-page.vue?vue&type=script&lang=js"
export * from "./pay-page.vue?vue&type=script&lang=js"
import style0 from "./pay-page.vue?vue&type=style&index=0&id=5697875b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports